module.exports = __webpack_public_path__ + "img/icon-menu-kpi.7de8b990.png";